export default __webpack_public_path__ + "static/media/The Kruks Photography-843_tn.e1fd5f9f.jpg";